import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaPlay } from 'react-icons/fa';

// Import video thumbnail (placeholder path, will need to be updated)
// import videoThumbnail from '../../assets/images/introVideo.png';
// Video thumbnail will be referenced directly from public folder

const AboutSection = () => {
  return (
    <section className="py-16">
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          {/* Left Column - Text Content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="bg-white/80 backdrop-blur-lg border border-white/30 shadow-xl rounded-2xl p-8 transition-all duration-300 hover:shadow-2xl hover:-translate-y-1"
          >
            <h4 className="text-2xl font-bold mb-3 bg-clip-text text-transparent bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500">
              STEM Education for Coming Future
            </h4>
            <p className="text-gray-700 mb-6">
              We have specially designed our courses to improve children's knowledge and technical skills.
              Our main focus is to create a talented student which he/she will be an innovator or entrepreneur in the future and create a gateway to the future job market.
            </p>
            <Link 
              to="/courses" 
              className="modern-button inline-flex items-center px-6 py-2.5 rounded-full font-semibold text-base shadow-md hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-indigo-400 transition-all duration-300"
            >
              Join US <span className="ml-2">→</span>
            </Link>
          </motion.div>
          
          {/* Right Column - Video */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="relative"
          >
            <img 
              src="/images/introVideo.png" 
              alt="STEM Labs Introduction" 
              className="w-full rounded-lg shadow-lg"
            />
            <div className="absolute inset-0 flex items-center justify-center">
              <a 
                href="https://www.youtube.com/watch?v=BMmajcwGr6c" 
                target="_blank"
                rel="noopener noreferrer"
                className="bg-theme-secondary text-white w-16 h-16 rounded-full flex items-center justify-center transform transition-transform hover:scale-110"
              >
                <FaPlay className="ml-1" />
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection; 